import { jsx as _jsx } from "react/jsx-runtime";
import { Text } from '@famly/mf_data-display_text';
import { Stack } from '@famly/mf_layout_stack';
export const Initials = ({ compact, initials, wrapperProps, textProps }) => {
    return (_jsx(Stack, { width: "100%", height: "100%", borderRadius: "50%", alignItems: "center", justifyContent: "center", backgroundColor: "b100", ...wrapperProps, children: _jsx(Text, { variant: compact ? 'h5' : 'h2', color: "b400", ...textProps, children: initials }) }));
};
